module.exports = __webpack_public_path__ + "fb-white.svg?a75369d09c09d3c03b98fd8626f92e1a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/social-media/fb-white.svg
// module id = 36
// module chunks = 0